/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_TitleInputs */

const en_pronunciation_report_title = /** @type {(inputs: Pronunciation_Report_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggest a pronunciation`)
};

const es_pronunciation_report_title = /** @type {(inputs: Pronunciation_Report_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugiere una pronunciación`)
};

/**
* | output |
* | --- |
* | "Suggest a pronunciation" |
*
* @param {Pronunciation_Report_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_title = /** @type {((inputs?: Pronunciation_Report_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_title(inputs)
	return en_pronunciation_report_title(inputs)
});